import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

type AppRole = "admin" | "employee" | "customer";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: AppRole[];
}

export default function ProtectedRoute({ children, requiredRoles }: ProtectedRouteProps) {
  const { user, loading, roles } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    // Preserve tenant context: if on /loja/:slug/*, redirect to /loja/:slug/auth
    const tenantMatch = location.pathname.match(/^(\/loja\/[^/]+)/);
    const authPath = tenantMatch ? `${tenantMatch[1]}/auth` : "/auth";
    return <Navigate to={authPath} replace />;
  }

  if (requiredRoles && requiredRoles.length > 0) {
    const hasRequiredRole = requiredRoles.some((r) => roles.includes(r));
    if (!hasRequiredRole) return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
